import z from 'zod'
import { GeoImageSchema } from './GeoImage.schema'
import { GeoImagesByTypeDto } from '../../domain/dtos/GeoImagesByType.dto'

export const GeoImagesByTypeSchema = z
	.object({
		imagens_drone: GeoImageSchema.array(),
		imagens_lidar: GeoImageSchema.array(),
		imagens_mdt: GeoImageSchema.array(),
		imagens_satelite: GeoImageSchema.array(),
	})
	.transform(
		(data): GeoImagesByTypeDto => ({
			drone: data.imagens_drone,
			lidar: data.imagens_lidar,
			mdt: data.imagens_mdt,
			satelite: data.imagens_satelite,
		}),
	)
